import { useCallback, useEffect, useState } from "react";

// 가맹점주 화면 주소: #inq · #inq/{id} · #log · #log/{id} — 그 밖은 챗봇 첫 화면
export function parseHash(h) {
    const m = /^#(inq|log)(?:\/(\d+))?$/.exec(h || "");
    return m ? { view: m[1], id: m[2] ? Number(m[2]) : null } : { view: null, id: null };
}

export function useHashRoute() {
    const [route, setRoute] = useState(() => parseHash(window.location.hash));
    useEffect(() => {
        const on = () => setRoute(parseHash(window.location.hash));
        window.addEventListener("hashchange", on);
        return () => window.removeEventListener("hashchange", on);
    }, []);
    // go("inq/7") · go("") — 빈 값은 첫 화면, 주소의 # 를 지운다
    const go = useCallback((h) => {
        if (h) { window.location.hash = h; return; }
        window.history.pushState(null, "", window.location.pathname + window.location.search);
        setRoute(parseHash(""));
    }, []);
    return [route, go];
}
